'use client';

import React from 'react';

const SERVICE_AREAS = [
  { name: 'Spokane', note: '' },
  { name: 'Post Falls', note: '' },
  { name: "Coeur d\'Alene", note: '' },
  { name: 'Airway Heights', note: '' },
  { name: 'Deer Park', note: '' },
];

interface CalendarSectionProps {
  onBookNow?: () => void;
}

export default function CalendarSection({ onBookNow }: CalendarSectionProps) {
  return (
    <section
      id="about"
      className="py-24 px-4 md:px-8"
      style={{ borderTop: '1px solid rgba(139,105,20,0.15)' }}
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <p
              className="text-[9px] font-bold uppercase tracking-[0.5em] mb-3"
              style={{ color: '#8B6914' }}
            >
              Where We Shoot
            </p>
            <h2
              className="font-display font-bold"
              style={{ fontSize: 'clamp(1.8rem, 5vw, 3rem)', color: '#E8E4DC', lineHeight: 1.1 }}
            >
              Areas We Serve
            </h2>
          </div>
          <button
            className="btn-gold"
            onClick={() => onBookNow?.()}
          >
            <span>Book a Session</span>
          </button>
        </div>

        {/* Base location callout */}
        <div
          className="mb-10 px-6 py-4 rounded-sm flex items-center gap-3"
          style={{ background: 'rgba(139,105,20,0.08)', border: '1px solid rgba(139,105,20,0.25)' }}
        >
          <svg
            className="flex-shrink-0"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#D4A843"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            <circle cx="12" cy="9" r="2.5" />
          </svg>
          <p className="text-sm" style={{ color: 'rgba(232,228,220,0.75)' }}>
            <span style={{ color: '#D4A843', fontWeight: 600 }}>Based in Spokane Valley</span>
            {' '}— serving the greater Spokane region and surrounding communities.
          </p>
        </div>

        {/* Areas list */}
        <div className="flex flex-col gap-3">
          {SERVICE_AREAS?.map((area, index) => (
            <div
              key={area?.name}
              className="flex items-center gap-4 px-6 py-5 rounded-sm"
              style={{
                background: 'rgba(26,26,46,0.5)',
                border: '1px solid rgba(139,105,20,0.18)',
              }}
            >
              <span
                className="text-[10px] font-bold"
                style={{ color: 'rgba(139,105,20,0.5)', minWidth: '1.5rem' }}
              >
                {String(index + 1)?.padStart(2, '0')}
              </span>
              <span
                className="font-display font-semibold text-lg"
                style={{ color: '#E8E4DC' }}
              >
                {area?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}